module.exports = __webpack_public_path__ + "img/popup_abril_2026_2.dd8afef4.png";